import {css, cx} from "@panda/css";

import {mb} from "@pg-design/helpers-css";
import {Tabs} from "@pg-design/tabs";
import {FormActions} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {useMapRegionDistrictsAndSurroundings} from "../../../offer/map/hooks/use_map_region_districts_and_surroundings";
import {searchFormFields} from "../../constants/search_form_constants";
import {useMeasuredDropdownMaxHeight} from "../../hooks/use_measured_dropdown_max_height";
import {useRegionSearchTabs} from "../../hooks/use_region_search_tabs";
import {RegionSearchTabsType} from "../../types/RegionSearchTabsType";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchTab} from "../../types/SearchTab";
import {ISearchInputValue} from "../ISearchInputValue";
import {SearchInteractiveRegionsMap} from "../search_interactive_regions_map/SearchInteractiveRegionsMap";
import {TimeTravelSelects} from "../TimeTravelSelects";
import {IDropdownListOwnProps, SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

export type ISearchAutocompleteDropdownWithTimeTravelProps = {
    isInModal?: boolean;
    onSearchSubmit: () => void;
    onTravelTimeCancel: () => void;
    regionSearchTabChangeHandler: (tab: RegionSearchTabsType) => void;
    defaultDistanceValue: number;
    formValues: SearchFormValuesType;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formActions: FormActions<Record<keyof typeof searchFormFields, any>>;
    updateSelectedRegions: (option: ISearchInputValue) => void;
} & ReturnType<typeof useRegionSearchTabs> &
    Required<Pick<IDropdownListOwnProps, "isSearchButtonActive" | "getFieldProps">>;

type IOwnProps = Omit<IDropdownListOwnProps, "isSearchButtonActive" | "getFieldProps">;

export const SearchAutocompleteDropdownWithRegionAdjustments = (props: ISearchAutocompleteDropdownWithTimeTravelProps & IOwnProps) => {
    const {isInModal, dropdownIsOpen, activeRegionSearchTab, regionSearchTabs, regionSearchTabChangeHandler, onSearchSubmit, onTravelTimeCancel} = props;
    const isTravelTabActive = activeRegionSearchTab === RegionSearchTabsType.TRAVEL_TIME;
    const {isMobile} = useUserDevice();

    const {ref: dropdownRef, style: dropdownMaxHeightStyle} = useMeasuredDropdownMaxHeight({
        isActive: dropdownIsOpen && !isMobile
    });

    const {waitForRegion} = useMapRegionDistrictsAndSurroundings({
        selectedRegions: props.search.tabType === SearchTab.Regions ? props.search.regions : null
    });

    const onLinkClick = (option: ISearchInputValue) => {
        const customCloseAction = (closeDropdown: () => void) => {
            if (activeRegionSearchTab !== RegionSearchTabsType.LOCATION) {
                return;
            }

            waitForRegion((params) => {
                if (!params.hasValidSurroundings || !params.hasAnyValidDistricts) {
                    closeDropdown();
                }
            });
        };

        props.onLinkClick(option, customCloseAction);
    };

    if (!dropdownIsOpen) {
        return null;
    }

    return (
        <div ref={dropdownRef} className={cx(wrapperBase, !isTravelTabActive && wrapperScrollable)} style={dropdownMaxHeightStyle}>
            {!isInModal && (
                <Tabs
                    activeColor="full-dark"
                    onChange={regionSearchTabChangeHandler}
                    color="gray"
                    tabs={regionSearchTabs}
                    value={activeRegionSearchTab ?? undefined}
                    variant="line"
                    fullWidth
                    css={mb(3)}
                />
            )}
            {activeRegionSearchTab === RegionSearchTabsType.DISTRICTS ? (
                <SearchInteractiveRegionsMap
                    formValues={props.formValues}
                    formActions={props.formActions}
                    defaultDistanceValue={props.defaultDistanceValue}
                    updateSelectedRegions={props.updateSelectedRegions}
                    search={props.search}
                    isInModal={isInModal}
                    onSearchSubmit={onSearchSubmit}
                />
            ) : (
                <>
                    <SearchAutocompleteDropdown
                        dropdownIsOpen={props.dropdownIsOpen}
                        search={props.search}
                        selectedTab={props.selectedTab}
                        onLinkClick={onLinkClick}
                        requestStateObj={props.requestStateObj}
                        activeItem={props.activeItem}
                        offers={props.offers}
                        places={props.places}
                        regions={props.regions}
                        removeRegionTag={props.removeRegionTag}
                        vendors={props.vendors}
                        useTravelTime={isTravelTabActive}
                        getFieldProps={props.getFieldProps}
                    />
                    {isTravelTabActive && (
                        <TimeTravelSelects
                            onClose={() => {
                                props.onClose?.();
                            }}
                            getFieldProps={props.getFieldProps}
                            onSubmit={onSearchSubmit}
                            updateTravelTimeState={props.setTravelTimeData}
                            prevDistance={props.prevDistance}
                            onCancel={onTravelTimeCancel}
                            placesArrayNotEmpty={props.places.length > 0}
                            isInModal={isInModal}
                        />
                    )}
                </>
            )}
        </div>
    );
};

/** Fallback when JS measure not yet available; overridden by measured maxHeight on desktop */
const wrapperBase = css({
    md: {
        maxHeight: "74rem"
    }
});

const wrapperScrollable = css({
    md: {
        overflowY: "auto",
        overflowX: "hidden"
    }
});
import {css, cx} from "@panda/css";

import {mb} from "@pg-design/helpers-css";
import {Tabs} from "@pg-design/tabs";
import {FormActions} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {useMapRegionDistrictsAndSurroundings} from "../../../offer/map/hooks/use_map_region_districts_and_surroundings";
import {searchFormFields} from "../../constants/search_form_constants";
import {useMeasuredDropdownMaxHeight} from "../../hooks/use_measured_dropdown_max_height";
import {useRegionSearchTabs} from "../../hooks/use_region_search_tabs";
import {RegionSearchTabsType} from "../../types/RegionSearchTabsType";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchTab} from "../../types/SearchTab";
import {ISearchInputValue} from "../ISearchInputValue";
import {SearchInteractiveRegionsMap} from "../search_interactive_regions_map/SearchInteractiveRegionsMap";
import {TimeTravelSelects} from "../TimeTravelSelects";
import {IDropdownListOwnProps, SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

export type ISearchAutocompleteDropdownWithTimeTravelProps = {
    isInModal?: boolean;
    onSearchSubmit: () => void;
    onTravelTimeCancel: () => void;
    regionSearchTabChangeHandler: (tab: RegionSearchTabsType) => void;
    defaultDistanceValue: number;
    formValues: SearchFormValuesType;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formActions: FormActions<Record<keyof typeof searchFormFields, any>>;
    updateSelectedRegions: (option: ISearchInputValue) => void;
} & ReturnType<typeof useRegionSearchTabs> &
    Required<Pick<IDropdownListOwnProps, "isSearchButtonActive" | "getFieldProps">>;

type IOwnProps = Omit<IDropdownListOwnProps, "isSearchButtonActive" | "getFieldProps">;

export const SearchAutocompleteDropdownWithRegionAdjustments = (props: ISearchAutocompleteDropdownWithTimeTravelProps & IOwnProps) => {
    const {isInModal, dropdownIsOpen, activeRegionSearchTab, regionSearchTabs, regionSearchTabChangeHandler, onSearchSubmit, onTravelTimeCancel} = props;
    const isTravelTabActive = activeRegionSearchTab === RegionSearchTabsType.TRAVEL_TIME;
    const {isMobile} = useUserDevice();

    const {ref: dropdownRef, style: dropdownMaxHeightStyle} = useMeasuredDropdownMaxHeight({
        isActive: dropdownIsOpen && !isMobile
    });

    const {waitForRegion} = useMapRegionDistrictsAndSurroundings({
        selectedRegions: props.search.tabType === SearchTab.Regions ? props.search.regions : null
    });

    const onLinkClick = (option: ISearchInputValue) => {
        const customCloseAction = (closeDropdown: () => void) => {
            if (activeRegionSearchTab !== RegionSearchTabsType.LOCATION) {
                return;
            }

            waitForRegion((params) => {
                if (!params.hasValidSurroundings || !params.hasAnyValidDistricts) {
                    closeDropdown();
                }
            });
        };

        props.onLinkClick(option, customCloseAction);
    };

    if (!dropdownIsOpen) {
        return null;
    }

    return (
        <div ref={dropdownRef} className={cx(wrapperBase, !isTravelTabActive && wrapperScrollable)} style={dropdownMaxHeightStyle}>
            {!isInModal && (
                <Tabs
                    activeColor="full-dark"
                    onChange={regionSearchTabChangeHandler}
                    color="gray"
                    tabs={regionSearchTabs}
                    value={activeRegionSearchTab ?? undefined}
                    variant="line"
                    fullWidth
                    css={mb(3)}
                />
            )}
            {activeRegionSearchTab === RegionSearchTabsType.DISTRICTS ? (
                <SearchInteractiveRegionsMap
                    formValues={props.formValues}
                    formActions={props.formActions}
                    defaultDistanceValue={props.defaultDistanceValue}
                    updateSelectedRegions={props.updateSelectedRegions}
                    search={props.search}
                    isInModal={isInModal}
                    onSearchSubmit={onSearchSubmit}
                />
            ) : (
                <>
                    <SearchAutocompleteDropdown
                        dropdownIsOpen={props.dropdownIsOpen}
                        search={props.search}
                        selectedTab={props.selectedTab}
                        onLinkClick={onLinkClick}
                        requestStateObj={props.requestStateObj}
                        activeItem={props.activeItem}
                        offers={props.offers}
                        places={props.places}
                        regions={props.regions}
                        removeRegionTag={props.removeRegionTag}
                        vendors={props.vendors}
                        useTravelTime={isTravelTabActive}
                        getFieldProps={props.getFieldProps}
                    />
                    {isTravelTabActive && (
                        <TimeTravelSelects
                            onClose={() => {
                                props.onClose?.();
                            }}
                            getFieldProps={props.getFieldProps}
                            onSubmit={onSearchSubmit}
                            updateTravelTimeState={props.setTravelTimeData}
                            prevDistance={props.prevDistance}
                            onCancel={onTravelTimeCancel}
                            placesArrayNotEmpty={props.places.length > 0}
                            isInModal={isInModal}
                        />
                    )}
                </>
            )}
        </div>
    );
};

/** Fallback when JS measure not yet available; overridden by measured maxHeight on desktop */
const wrapperBase = css({
    md: {
        maxHeight: "74rem"
    }
});

const wrapperScrollable = css({
    md: {
        overflowY: "auto",
        overflowX: "hidden"
    }
});
